namespace h5_vm {

   import IPromise = angular.IPromise;
   import IQService = angular.IQService;
   import VmProvisioningPageModel = h5_vm.VmProvisioningPageModel;
   const type: string = "com.vmware.vcenter.ovf.DeploymentOptionParams";

   class VmProvisioningDeploymentOptionsPageModelFactory {
      public static $inject = [
         "$q",
         "i18nService"
      ];

      constructor( $q: IQService,
            i18nService: any
      ) {
         return (virtualMachineSpecBuilder: any, wizardViewData: any) => {
            return new VmProvisioningDeploymentOptionsPageModel(
                  $q,
                  i18nService,
                  virtualMachineSpecBuilder,
                  wizardViewData);
         };
      }
   }

   export class VmProvisioningDeploymentOptionsPageModel implements VmProvisioningPageModel<any> {
      static $inject: string[] = [
         "$q",
         "i18nService"
      ];

      private wizardViewDataObj: any;
      private virtualMachineSpecBuilderObj: any;
      private formObj: any = {
         deploymentOptionParams: undefined
      };

      constructor(
         private $q: IQService,
         private i18nService: any,
         virtualMachineSpecBuilder: any,
         wizardViewData: any) {
         this.virtualMachineSpecBuilderObj = virtualMachineSpecBuilder;
         this.wizardViewDataObj = wizardViewData;
      }

      get form(): any {
         this.formObj.deploymentOptionParams = this.retrieveCommonContext();
         return this.formObj;
      }

      get wizardViewData(): any {
         return this.wizardViewDataObj;
      }

      get virtualMachineSpecBuilder(): any {
         return this.virtualMachineSpecBuilderObj;
      }

      public validatePage(): Object {
         return {};
      }

      public submitPage(): any {
         return {
            wizardFlow: this.virtualMachineSpecBuilderObj.getCreationType(),
            invalidateNextPages: false
         };
      }

      private retrieveCommonContext(): any {
         return _.find(
            this.wizardViewDataObj.getDeployFromLibraryCommonContext(),
            (item: any) => {
               return (_.isEqual(item._type, type));
            });
      }

      public resetForm(): void{}
   }

   angular.module("com.vmware.vsphere.client.vm")
      .service("vmProvisioningDeploymentOptionsPageModel",
            VmProvisioningDeploymentOptionsPageModelFactory);
}
